import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLangPrefix } from "../i18n";

export default function AdminRoute({ children }) {
  const { user } = useAuth();
  const lp = useLangPrefix();
  if (!user) return <Navigate to={`${lp}/login`} replace />;
  if (!user.isAdmin) return <Navigate to={`${lp}/home`} replace />;
  return children;
}
